import {
  CollectionForMetadata_collection,
  CollectionPageContents_collection,
  Visibility,
} from 'globalTypes'

import Header from 'Root/App/Header'
import ShareOrCopyHeader from 'Root/App/Header/Buttons/ShareOrCopy'
import Container from 'Root/App/Menu/Container'

import CallToAction from '../CallToAction'
import styles from './index.module.css'

interface CollectionHeaderProps {
  collection: CollectionForMetadata_collection
  me: any
}

const CollectionHeader = ({ collection, me }: CollectionHeaderProps) => {
  const notCanShare =
    !collection.canManage &&
    (collection.visibility === Visibility.private ||
      collection.visibility === Visibility.mine)

  const creator = {
    profileName: collection.creator.vanity_name,
    logoURL: collection.creator.brandLogoSmall,
  }

  return (
    <Header creator={creator}>
      <CallToAction
        userID={me?.id}
        collection={collection as CollectionPageContents_collection}
      />

      {!notCanShare && (
        <ShareOrCopyHeader id={collection.id} key={`share_${collection.id}`} />
      )}

      {!!me && (
        <Container
          buttonSize="S"
          className={styles.headerButton}
          key={`menu_${collection.id}`}
        />
      )}
    </Header>
  )
}

export default CollectionHeader
